import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./usermanagement.css";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { extractDate, extractOnlyDate, subadminAccessChange } from "../../utils/functions";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";
import ReactReadMoreReadLess from "react-read-more-read-less";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from "@material-ui/core";

// icons 
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";

import certificate from "../../assets/images/ApproveCertificate.png";
import vector from "../../assets/images/Vector.png";

// Elements

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    DeleteButton,
    ProfileDetailForm,
    SelectedColumnContainer,
} from "./UserManagementElements";
import zIndex from "@material-ui/core/styles/zIndex";
import NoResults from "../../components/NoResult";


const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        // border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none"
    },
    textMiddle: {
        // padding: "0.4rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));


const CertificateRequest = ({ setUsers, userData }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const feedbackManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Blacklist Word Management"
    )?.permissions || {};


    const canView = !!feedbackManagementPermissions.view;
    const canAdd = !!feedbackManagementPermissions.add;
    const canEdit = !!feedbackManagementPermissions.edit;
    const canDelete = !!feedbackManagementPermissions.delete;
    const canBlockUnblock = !!feedbackManagementPermissions.blockUnblock;
    const canDownload = !!feedbackManagementPermissions.download;

    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [excelData, setExcelData] = useState([]);


    const [deleteModal, setDeleteModal] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");

    const [certificateId, setCertificateId] = useState(null);
    const [approvedCertificate, setApprovedCertificate] = useState(false);
    const [rejectCertificate, setRejectCertificate] = useState(false);
    const [verificationDocumentModal, setVerificationDocumentModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(""); // Store clicked image source
    const [selectedUser, setSelectedUser] = useState(null);
    const [rejectionReason, setRejectionReason] = useState("");

    const [sorting, setSorting] = useState({
        sortByUserName: null,
        sortByUploadedDate: null,
        defaultSorting: -1,
    });
    const [rotations, setRotations] = useState({
        sortByUserName: 0,
        sortByUploadedDate: 0,
    });








    const handleImageClick = (imageSrc, user) => {
        setSelectedUser(user); // pura user object save
        setCertificateId(user?._id); // id bhi save
        setSelectedImage(imageSrc);
        setVerificationDocumentModal(true);
    };



    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };


    // For Select checkbox
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map((item) => item._id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
    };

    const [anchorEl, setAnchorEl] = useState(null);



    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };



    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;

    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };



    // Get user data
    useEffect(() => {
        getAllUserCertificate(page)

    }, [page, rowsPerPage, searchTerm, filterStatus]);



    const toggleSort = (field) => {
        setSorting((prev) => {
            let newSorting = {
                sortByUserName: null,
                sortByUploadedDate: null,
                defaultSorting: null,
            };

            let newValue = prev[field] === 1 ? -1 : 1;
            newSorting[field] = newValue;

            //Rotate image toggle
            setRotations((prev) => ({
                ...prev,
                [field]: prev[field] === 0 ? 180 : 0, // toggle between 0 and 180
            }));

            // API call
            getAllUserCertificate(1, newSorting);

            return newSorting;
        });
    };

    const getAllUserCertificate = async (currentPage, sortingParam = sorting) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.post(`/private/getAllUserCertificate?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
                ...sortingParam,
            });

            console.log("getAllUserCertificate", data)

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };



    // approve && Reject
    const handleApprove = async (id) => {
        setIsLoading(true)
        try {
            const response = await axios.put(`/private/certificate/approvedRejected/${id}`,
                {
                    status: "2",   //3 reject and 2 Approve        
                }
            );
            toast.success(response.data.message, {
                position: "top-right",
            });
            setVerificationDocumentModal(false)
            getAllUserCertificate(page);
        } catch (error) {

            if (error.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                toast.error(error.response.data?.message, {
                    position: "top-right",
                });
                navigate("/");
            } else {
                toast.error("Something went wrong", {
                    position: "top-right",
                });
            }
        }
    };

    const handleReject = async (id) => {
        if (!rejectionReason.trim()) {
            toast.error("Please enter a reason for rejection.");
            setRejectCertificate(true)

            return;
        }

        setIsLoading(true);
        try {
            const response = await axios.put(`/private/certificate/approvedRejected/${id}`, {
                status: "3", // 3 = Rejected
                rejectionReason: rejectionReason.trim()
            });
            toast.success(response.data.message, {
                position: "top-right",
            });
            setVerificationDocumentModal(false)
            getAllUserCertificate(page);
        } catch (error) {

            if (error.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                toast.error(error.response.data?.message, {
                    position: "top-right",
                });
                navigate("/");
            } else {
                toast.error("Something went wrong", {
                    position: "top-right",
                });
            }
        }
    };




    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <DashboardHeading>
                                Certificate Request
                            </DashboardHeading>


                            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                <SearchBar
                                    style={{
                                        minWidth: "25rem",
                                        height: "38px",
                                        borderRadius: "20px",
                                        backgroundColor: "#F8F9FB",
                                        color: "#212121",
                                        fontStyle: "Italic",
                                        fontWeight: 300,
                                        fontSize: "15px",
                                        fontFamily: "Roboto",
                                    }}
                                    className={"heightfix"}
                                    onChange={(e) => {
                                        SearchAccountManagement(e);
                                    }}
                                    onCancelSearch={cancelSearch}
                                    placeholder="Search Username..."
                                    inputProps={{ maxLength: 30 }}
                                />
                            </div>
                        </div>




                        {selectedRows.length > 0 && (
                            <SelectedColumnContainer>
                                <DeleteButton
                                    type="button"
                                    className="buttonWidthResponsive"
                                    onClick={() => {
                                        setDeleteModal(true);
                                    }}
                                >
                                    Delete
                                </DeleteButton>
                                <div className="column-selected">{selectedRows.length} Selected</div>
                                <div
                                    className="container-clear-selection"
                                    onClick={handleClearSelection}
                                >
                                    <RxCrossCircled />
                                    <span className="column-selected">Clear Response</span>
                                </div>
                            </SelectedColumnContainer>
                        )}

                        <TableContainer
                            className={classes.tableMainContainer}
                        >
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>
                                        <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell>
                                         <TableCell className={classes.tableHeadingCell}>
                                            Name
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            User Name{" "}
                                            <img
                                                src={vector}
                                                style={{
                                                    cursor: "pointer",
                                                    transition: "transform 0.3s ease",
                                                    transform: `rotate(${rotations.sortByUserName}deg)`,
                                                }}
                                                onClick={() => toggleSort("sortByUserName")}
                                            />
                                        </TableCell>
                                         <TableCell className={classes.tableHeadingCell}>
                                            Email
                                        </TableCell>

                                        <TableCell className={classes.tableHeadingCell}>
                                            Uploaded Date{" "}
                                            <img
                                                src={vector}
                                                style={{
                                                    cursor: "pointer",
                                                    transition: "transform 0.3s ease",
                                                    transform: `rotate(${rotations.sortByUploadedDate}deg)`,
                                                }}
                                                onClick={() => toggleSort("sortByUploadedDate")}
                                            />
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Certificate Name
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Certificate Id
                                        </TableCell>
                                         <TableCell className={classes.tableHeadingCell}>
                                           Provider institute
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                           Issue date
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Certificate
                                        </TableCell>

                                    </TableRow>
                                </TableHead>
                                {tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((user, index, block) => (
                                                <TableRow className={classes.tableBodyRow} key={user._id}>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell>
                                                     <TableCell className={classes.textMiddle}>
                                                        <div>{(get(user, "fullName", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            color: "#5088FB",
                                                            cursor: "pointer"
                                                        }}
                                                            onClick={() => navigate(`/userDetails/${user.userId}`,
                                                                { state: { from: "feedbackManagement" } })}
                                                        >
                                                            {get(user, "userName", "---")}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{(get(user, "email", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{extractOnlyDate(get(user, "createdAt", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{(get(user, "certificateName", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{(get(user, "certificateId", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{(get(user, "issueBy", "---"))}</div>
                                                    </TableCell>
                                                     <TableCell className={classes.textMiddle}>
                                                        <div>{extractOnlyDate(get(user, "issueDate", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{
                                                            color: "#29A4C0",
                                                            textDecoration: "underline",
                                                            cursor: "pointer"
                                                        }}
                                                            onClick={() => handleImageClick(user?.uploadCertificate, user)}

                                                        >{get(user, "uploadCertificate") ? (
                                                            <span>Show Certificate</span>
                                                        ) : (
                                                            <span>N/A</span>
                                                        )}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                                                    <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}
                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>

            {/* Modal for Showing Document */}

            <Modal
                maxWidth="lg"
                width="400px"
                RoundedCorners={true}
                isOpen={verificationDocumentModal}
                onClose={() => setVerificationDocumentModal(false)}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "1rem"
                    }}>
                        <div className="common-heading">Certificate</div>
                        <RxCross2
                            style={{ cursor: "pointer" }}
                            onClick={() => setVerificationDocumentModal(false)}
                        />
                    </div>
                }
                content={
                    <div className="send-take-pkg-cant text-center">
                        {/* 
                        <img
                            src={selectedImage}
                            alt="Selected Document"
                            style={{
                                height: "14rem",
                                width: "22rem",
                                borderRadius: "10px",
                                border: "1px solid #00000038"

                            }}
                        /> */}

                        {selectedImage && (
                            selectedImage.endsWith('.pdf') ? (
                                <iframe
                                    src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedImage)}&embedded=true`}
                                    style={{
                                        height: "25rem",
                                        width: "100%",
                                        borderRadius: "10px",
                                        border: "1px solid #00000038"
                                    }}
                                    frameBorder="0"
                                />
                            ) : (
                                <img
                                    src={selectedImage}
                                    alt="Selected Document"
                                    style={{
                                        height: "14rem",
                                        width: "22rem",
                                        borderRadius: "10px",
                                        border: "1px solid #00000038"
                                    }}
                                />
                            )
                        )}



                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "0.8rem",
                            padding: "0.8rem"

                        }}>
                            <div
                                style={{
                                    padding: "5px 1.5rem",
                                    background: "#FF4141",
                                    color: "#FFFFFF",
                                    fontFamily: "Inter",
                                    fontWeight: "400",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setRejectCertificate(true);
                                }}
                            >
                                Reject
                            </div>
                            <div
                                style={{
                                    width: "6rem",
                                    padding: "5px 1.1rem",
                                    background: "#2CA63F",
                                    color: "#FFFFFF",
                                    fontFamily: "Inter",
                                    fontWeight: "400",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                                onClick={() => {
                                    setApprovedCertificate(true);
                                }}
                            >
                                Approve
                            </div>
                        </div>
                    </div>
                }
            />


            {/* Model for Approved Certificate */}
            < Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={approvedCertificate}
                onClose={() => {
                    setApprovedCertificate(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div div >
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2 style={{ cursor: "pointer" }} onClick={() => setApprovedCertificate(false)} />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "10px", }}>
                            <img src={certificate} style={{ height: "3.5rem" }} />
                        </div>

                        <div className="block-header">Are you sure you want to approve this certificate ?</div>
                    </div >
                }
                content={
                    <>
                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setApprovedCertificate(false);

                                }}
                            >
                                Cancel
                            </div>
                            <div
                                className="logout-button"
                                style={{ background: "#5088FB", cursor: "pointer" }}

                                onClick={() => {
                                    setApprovedCertificate(false);
                                    setVerificationDocumentModal(false);
                                    if (certificateId) {
                                        handleApprove(certificateId); // yaha user ki id pass ho rahi h
                                    }
                                }}
                            >
                                Yes.
                            </div>

                        </div>
                    </>
                }
            />


            {/* Model for Reject Certificate */}


            <Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={rejectCertificate}
                onClose={() => setRejectCertificate(false)}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div>
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                    setRejectCertificate(false);
                                    setRejectionReason("");
                                }}
                            />
                        </div>
                        <p className="user_info">Reject Certificate Reason</p>
                        <div className="block-header">
                            Please provide a reason for rejecting this certificate
                        </div>
                    </div>
                }
                content={
                    <>
                        <textarea
                            placeholder="Write Reject reason..."
                            className="reject-textarea"
                            style={{
                                height: "6rem",
                                width: "100%",
                                background: " #F3F7FF",
                                border: "1px solid #00000038",
                                padding: "0.5rem"
                            }}
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                        ></textarea>

                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setRejectCertificate(false);
                                    setRejectionReason(""); // reset
                                }}
                            >
                                Cancel
                            </div>
                            <div
                                className="logout-button"
                                style={{ background: "#5088FB", cursor: "pointer" }}
                                onClick={() => {
                                    setVerificationDocumentModal(false);
                                    setRejectCertificate(false);
                                    if (certificateId) {
                                        handleReject(certificateId); // yaha user ki id pass ho rahi h
                                    }
                                    setRejectionReason("");
                                }}
                            >
                                Submit
                            </div>
                        </div>
                    </>
                }
            />


            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CertificateRequest);






